import { error as errorReducer } from './Error.reducer';
import {
    MYQUOTES_RECEIVE,
    MYQUOTES_ERROR,
    MYQUOTEDETAIL_RECEIVE,
    MYQUOTEDETAIL_ERROR,
    MYQUOTES_CHANGE_MODE,
} from '../Actions/MyQuotes.action';

const defaultState = {
    myQuotesList: [],
    selectedQuoteDetail: {},
    errors: {}
};

export const myQuotes = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case MYQUOTES_RECEIVE:
        case MYQUOTES_CHANGE_MODE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case MYQUOTES_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case MYQUOTEDETAIL_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case MYQUOTEDETAIL_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
